import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addRoom from "./guideSequence_addRoom";
import openRoomOrFloorSequence from "./multibleSequencesHelp";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let firstRoom = state.allRooms().filter((room) => !room.isFloorGeneralRoom)[0];
  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (!firstRoom) {
          return [
            {
              action: enumActions.explain,
              text: `das Project hat noch keinen Raum,
              also muss ich zunächst noch einen Raum anlegen`,
            },
            ...guideSequence_addRoom(""),
            { action: enumActions.wait },
          ];
        } else {
          return undefined;
        }
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        firstRoom = state.allRooms().filter((room) => !room.isFloorGeneralRoom)[0];
        state.selectionManager.selectedObject = firstRoom;
      },
    },
    {
      action: enumActions.call,
      subSequence: () => {
        const page = state.objectRegistry.getObject(state.activePaneId);

        if (page?.parent?.className == "Room") {
          return [];
        } else {
          if (!firstRoom) {
            firstRoom = state.allRooms().filter((room) => !room.isFloorGeneralRoom)[0];
          }
          return [...openRoomOrFloorSequence({ roomGiven: firstRoom })];
        }
      },
    },
  ];
}

export default sequence;
